"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomFields = exports.request = exports.configure = exports.query = void 0;
var tslib_1 = require("tslib");
var graphql_request_1 = require("graphql-request");
var runtime_context_1 = require("@drapejs/runtime-context");
var cross_fetch_1 = tslib_1.__importDefault(require("cross-fetch"));
var consola_1 = tslib_1.__importDefault(require("consola"));
function query(query) {
    var fragments = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        fragments[_i - 1] = arguments[_i];
    }
    return {
        query: query,
        fragments: new Set(fragments),
    };
}
exports.query = query;
var client;
var customQueryFields;
function configure(customFields) {
    customQueryFields = customFields || {};
}
exports.configure = configure;
function request(cache, query, variables, requestHeaders) {
    if (!client) {
        initClient(cache);
    }
    var payload = query.query;
    query.fragments.forEach(function (f) { return payload = payload + "\n" + f; });
    return client.rawRequest(payload, variables, requestHeaders);
}
exports.request = request;
function getCustomFields() {
    return customQueryFields;
}
exports.getCustomFields = getCustomFields;
function initClient(cache) {
    var _this = this;
    client = new graphql_request_1.GraphQLClient('', {
        fetch: function (_, options) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var litium, litiumOptions, resHeaders, baseUrl, promise;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!options.headers) {
                            options.headers = {};
                        }
                        return [4 /*yield*/, cache.getItem('__litium')];
                    case 1:
                        litium = (_a.sent()) || {};
                        return [4 /*yield*/, cache.getItem('__litium_options')];
                    case 2:
                        litiumOptions = (_a.sent()) || {};
                        return [4 /*yield*/, cache.getItem('__resHeaders')];
                    case 3:
                        resHeaders = _a.sent();
                        if (!litiumOptions || !litiumOptions.baseUrl) {
                            consola_1.default.error('drapejs-litium: No baseUrl found in __litium_options cache entry');
                            return [2 /*return*/];
                        }
                        if (litium.session) {
                            options.headers['LH-Session'] = litium.session;
                        }
                        else {
                            options.headers['LH-Session'] = '*';
                        }
                        if (litium.cart) {
                            options.headers['LH-Cart'] = litium.cart;
                        }
                        if (litium.uid) {
                            options.headers['LH-Uid'] = litium.uid;
                        }
                        if (litiumOptions.additionalHeaders) {
                            options.headers = tslib_1.__assign(tslib_1.__assign({}, options.headers), litiumOptions.additionalHeaders);
                        }
                        baseUrl = litiumOptions.baseUrl;
                        if (!(0, runtime_context_1.isNode)()) {
                            baseUrl = self.location.origin;
                        }
                        promise = (0, cross_fetch_1.default)(baseUrl + '/graphql', options);
                        promise.then(function (res) {
                            if (res.headers.get('LH-Session')) {
                                litium.session = res.headers.get('LH-Session');
                            }
                            if (res.headers.get('LH-Cart')) {
                                litium.cart = res.headers.get('LH-Cart');
                            }
                            if (res.headers.get('LH-Uid')) {
                                litium.uid = res.headers.get('LH-Uid');
                            }
                            if (!(0, runtime_context_1.isNode)()) {
                                cache.setItem('__litium', litium);
                            }
                            else if (!resHeaders) {
                                var headers = Object.fromEntries(res.headers.entries());
                                cache.setItem('__resHeaders', headers);
                            }
                            return res;
                        })
                            .catch(function (err) {
                            console.error(err);
                        });
                        return [2 /*return*/, promise];
                }
            });
        }); },
        "credentials": "include",
        "mode": "cors",
    });
}
//# sourceMappingURL=index.js.map